module.exports = __webpack_public_path__ + "feather.ttf?a940fe89dbfe9d1d89fc1aa0488fe032";


//////////////////
// WEBPACK FOOTER
// ./node_modules/at-ui-style/css/fonts/feather.ttf?t=1501829003743
// module id = 83
// module chunks = 0